// extracted by mini-css-extract-plugin
export default {"wrapper":"DeletedProject_wrapper__Jpxqb","user-progress-title":"DeletedProject_user-progress-title__WoNjd"};